var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg1 = function Svg1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F28230",
    d: "M7.124 17.217A7.13 7.13 0 0 1 0 10.094 7.13 7.13 0 0 1 7.124 2.97a7.13 7.13 0 0 1 7.124 7.124 7.13 7.13 0 0 1-7.124 7.123m0-13.124c-3.307 0-6 2.693-6 6s2.693 6 6 6 6-2.692 6-6-2.693-6-6-6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F28230",
    d: "M7.124 4.093a.56.56 0 0 1-.562-.561V1.344a.561.561 0 1 1 1.124 0v2.188c0 .31-.251.561-.562.561"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F28230",
    d: "M8.873 1.906H5.539a.561.561 0 1 1 0-1.124h3.334a.561.561 0 1 1 0 1.124M9.73 11.083H7.125a.56.56 0 0 1-.562-.562V6.805a.561.561 0 1 1 1.124 0V9.96H9.73a.561.561 0 1 1 0 1.124"
  })));
};
export default Svg1;